import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "playBtnInner" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "dialog"
}
const _hoisted_4 = {
  key: 1,
  class: "dialog"
}

import "video.js/dist/video-js.css";
import Loader from "@/components/chat/chatContainer/Loader.vue";
import { useStore } from "vuex";
import { GetterTypes } from "@/store";
import { ChatsActionTypes, ChatsMutationTypes } from "@/store/chats";
import { Attachment, TextMessage } from "@/store/chats/types";
import { computed, watch, onMounted } from "vue";
import { useComputedValue } from "@/composables";
import { VideoDisplayStatus } from "@/types/chat";
import { useVideoJsPlayerProperties } from "./useVideoJsPlayerProperties";
import EncodingLoader from "@/components/chat/chatContainer/EncodingLoader.vue";

interface VideoPlayerProps {
  message: TextMessage;
  attachment: Attachment;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  props: {
    message: {},
    attachment: {}
  },
  setup(__props: any) {

const props = __props;
const { commit, dispatch } = useStore();
const accessToken = useComputedValue<string>(GetterTypes.GET_AUTH_ACCESS_TOKEN);
const chatId = useComputedValue<string>(GetterTypes.GET_SELECTED_CHAT_ID);
const aspectRatio = computed(() => {
  return getAspectRatio();
});
const isVertical = computed(() => Number(aspectRatio.value) < 1);
const isLoading = computed(
  () =>
    (props.attachment.isUploading &&
      props.attachment.displayStatus === VideoDisplayStatus.Uploading) ||
    props.attachment.displayStatus === VideoDisplayStatus.Processing,
);
const videoId = computed(() => `player_${props.attachment.cdnId}`);
const attachmentIdx = computed(
  () =>
    props.message.allAttachments?.findIndex(
      (att) => att.cdnId === props.attachment.cdnId,
    ),
);
const displayStatus = computed(() => props.attachment.displayStatus);

const { videoRef, handleClick, initializePlayer } =
  useVideoJsPlayerProperties();

watch(displayStatus, () => {
  updateMetadata();
});

onMounted(() => {
  updateMetadata();
});

const updateMetadata = () => {
  const { url, thumbnailUrl } = props.attachment;
  if (displayStatus.value !== VideoDisplayStatus.Done) {
    return;
  }

  if (url && thumbnailUrl) {
    handleInitPlayer(url, thumbnailUrl);
    return;
  }
  addVideoAttachmentSources();
};

const addVideoAttachmentSources = async () => {
  const { cdnId } = props.attachment;
  if (!cdnId || attachmentIdx.value === undefined) {
    return;
  }
  const { url, thumbnailUrl } = await dispatch(
    ChatsActionTypes.UPDATE_ATTACHMENT_SOURCES,
    {
      videoCdnId: cdnId,
      accessToken: accessToken.value,
      chatId: chatId.value,
      messageId: props.message.id,
      attachmentIdx: attachmentIdx.value,
    },
  );

  handleInitPlayer(url, thumbnailUrl);
};

const handleInitPlayer = (url: string, thumbnailUrl: string) => {
  initializePlayer({
    posterSrc: thumbnailUrl,
    hlsSrc: url,
    elementId: videoId.value,
  });
};

const getAspectRatio = () => {
  if (props.attachment.dimensions) {
    const { width, height } = props.attachment.dimensions;
    const ratio = width / height;
    return ratio + "/1";
  }
  return "16/9";
};

const handleAbortUpload = () => {
  if (!props.attachment.isUploading || attachmentIdx.value === undefined) {
    return;
  }

  const args = {
    chatId: chatId.value,
    messageId: props.message.id,
    attachmentIdx: attachmentIdx.value,
  };

  dispatch(ChatsActionTypes.DELETE_ATTACHMENT, args);
  commit(ChatsMutationTypes.UPDATE_ATTACHMENT_IS_UPLOADING, {
    ...args,
    isUploading: false,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_video_js = _resolveComponent("video-js")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["attachment-video", { vertical: isVertical.value }]),
    style: _normalizeStyle({
      aspectRatio: aspectRatio.value,
    })
  }, [
    _createElementVNode("div", {
      ref_key: "videoRef",
      ref: videoRef,
      class: "videoContainer"
    }, [
      _createVNode(_component_video_js, {
        id: videoId.value,
        class: "videoJs"
      }, null, 8, ["id"]),
      (_ctx.attachment.displayStatus === _unref(VideoDisplayStatus).Done)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "playBtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleClick) && _unref(handleClick)(...args)))
          }, _hoisted_2))
        : _createCommentVNode("", true)
    ], 512),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : (
        _ctx.attachment.displayStatus === undefined ||
        _ctx.attachment.displayStatus === _unref(VideoDisplayStatus).Error
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t("chat.chatContainer.VideoPlayer.error")), 1))
        : _createCommentVNode("", true),
    (_ctx.attachment.displayStatus === _unref(VideoDisplayStatus).Uploading)
      ? (_openBlock(), _createBlock(Loader, {
          key: 2,
          progress: _ctx.attachment.uploadProgress,
          cancellable: _ctx.attachment.isUploading,
          onAbort: handleAbortUpload
        }, null, 8, ["progress", "cancellable"]))
      : _createCommentVNode("", true),
    (_ctx.attachment.displayStatus === _unref(VideoDisplayStatus).Processing)
      ? (_openBlock(), _createBlock(EncodingLoader, { key: 3 }))
      : _createCommentVNode("", true)
  ], 6))
}
}

})